<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="header accent-700 p-24">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <div class="mt-8">Duplicar Atendimento</div>
            <button mat-icon-button (click)="dimiss()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>


    <div mat-dialog-content class="p-12 pb-5 m-0">

        <form name="authorizationTokenForm" [formGroup]="copyForm" fxFlex="100" class="mt-5"
            style="display: block!important;" fxLayout="column" *ngIf="copyForm">
            <div fxLayout="column">
                <div fxLayout="row" fxLayoutGap="10">
                    <mat-form-field appearance="outline">
                        <mat-label>Data Atendimento</mat-label>
                        <input autocomplete="off" matInput [matDatepicker]="dateExecute" placeholder="Data Atendimento"
                            formControlName="date" />
                        <mat-datepicker-toggle id="dateExecute" matSuffix [for]="dateExecute">
                        </mat-datepicker-toggle>
                        <mat-datepicker #dateExecute></mat-datepicker>
                        <mat-error *ngIf="copyForm.get('date').hasError('required')">
                            O campo é obrigatório
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>Hora Atendimento</mat-label>
                        <input autocomplete="off" matInput type="text" mask="Hh:m0:s0" [dropSpecialCharacters]="false"  placeholder="Hora Atendimento"
                            formControlName="hour">
                            <mat-error *ngIf="copyForm.get('hour').hasError('required')">
                                O campo é obrigatório
                            </mat-error>
                    </mat-form-field>

                </div>
                <div fxLayout="row" fxLayoutGap="10">
                    <button id="authorizationTokenSave" [disable]="copyForm.valid" *ngIf="!progress" style="color: #1e527f;" mat-stroked-button
                        class="mr-12 button-authorization_token" mat-stroked-button (click)="confirm()">
                        Confirmar
                        <span class="material-icons">file_copy</span>
                    </button>

                </div>

            </div>
        </form>
    </div>
</div>